// © 2015-2021 WDNA - All Rights Reserved
import thunk from 'redux-thunk';

import { applyMiddleware, compose, legacy_createStore as createStore, Middleware, StoreEnhancer, Store } from 'redux';
import { routerMiddleware } from 'connected-react-router';

import { enhanceReduxMiddleware } from 'kepler.gl/middleware.js';

import { dumpLayoutToStorage, handleBodyClasses } from 'wdna-components/lib/layout/actions';

import { permissionMiddleware } from '../services/auth/helpers/permissions';

import rootReducer from '../reducers';
import history from './history';

const initialState: any = {};
// eslint-disable-next-line no-underscore-dangle
const composeEnhancer: typeof compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const middlewares: Middleware[] = enhanceReduxMiddleware([
  thunk,
  routerMiddleware(history),
  handleBodyClasses,
  dumpLayoutToStorage,
  permissionMiddleware
]);
export const enhancers: StoreEnhancer[] = [applyMiddleware(...middlewares)];

const store: Store = createStore(rootReducer(history), initialState, composeEnhancer(...enhancers));

window.store = store;

export default store;
